import { create } from 'zustand';

interface RealtimeState {
  typingUsers: Record<string, string[]>; // conversationId -> userNames
  setTyping: (conversationId: string, users: string[]) => void;
}

export const useRealtimeStore = create<RealtimeState>((set) => ({
  typingUsers: {},
  setTyping: (conversationId, users) => 
    set((state) => ({
      typingUsers: { ...state.typingUsers, [conversationId]: users }
    })),
}));
